/** Chat entry for portfolio screenshot / file upload (manage modal + ghost import). */
export const PORTFOLIO_UPLOAD_HOLDINGS_CHAT_QUESTION =
  "[portfolio/add_account](referenceType=portfolio_link)\n add a new account to my portfolio";
